export const createAccordion = (table, title) => {
  const header = document.createElement('div');
  header.className = 'event-comparison-table-accordian';
  header.id = `accordian_${table.id}`;

  // Create an arrow icon
  const arrowIcon = document.createElement('span');
  arrowIcon.className = 'event-comparison-table-accordian-arrow-icon';
  arrowIcon.innerHTML = '&#9654;'; // Right-pointing triangle (Unicode character)

  const titleNode = document.createElement('span');
  titleNode.innerHTML = title;

  const badgeNode = document.createElement('div');
  badgeNode.className = 'ect-badges';

  const titleWrapper = document.createElement('div');

  titleWrapper.appendChild(arrowIcon);
  titleWrapper.appendChild(titleNode);

  header.appendChild(titleWrapper);
  header.appendChild(badgeNode);

  const tableWrapper = document.createElement('div');
  tableWrapper.appendChild(table);
  tableWrapper.classList.add('event-comparison-table-wrapper');

  header.addEventListener('click', () => {
    tableWrapper.classList.toggle('event-comparison-table-accordian-active'); // Toggle the active class to show/hide the table
    let isOpen = tableWrapper.classList.contains(
      'event-comparison-table-accordian-active'
    );
    if (isOpen)
      tableWrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
    arrowIcon.innerHTML = isOpen ? '&#9660;' : '&#9654;'; // Change arrow direction
  });

  const tableHeader = document.createElement('div');
  tableHeader.id = `table_header_${table.id}`;

  // Append the header and the table to the panel body
  const pannelBody = document.getElementById('panel_events_body');
  tableHeader.appendChild(header);
  tableHeader.appendChild(tableWrapper);
  pannelBody.appendChild(tableHeader);
};
